import { Product } from '@/context/ecomProductContext';
import is from './is';
import { ECOM_INVENTORY_STATUS } from '@/constants/app';

export const isOutOfStock = (product: Product) => {
  const inventory = product?.inventory;
  if (is.null(inventory) || inventory?.inventoryStatus === ECOM_INVENTORY_STATUS.OUT_OF_STOCK)
    return true;
  return false;
};

export const isInCart = (inCartItems: string[], productId: string) =>
  inCartItems?.includes(productId);
